import axios from 'axios';

import Utils from '@/common/utils';

export default {
  search: function (request) {
    return axios.get('/api/mpkAssignment/search', { params: request });
  },
  orgList: function (request) {
    return axios.get('/api/mpkAssignment/orgList', { params: request });
  },
  getEventForList: function (request) {
    return axios.get('/api/mpkAssignment/getEventForList', { params: request });
  },
  getMpkRegistryAssignmentStatusList: function () {
    return axios.get('api/MpkAssignment/getMpkRegistryAssignmentStatusList');
  },
  getTotal: function (request) {
    return axios.get('/api/mpkAssignment/getTotal', { params: request });
  },
  getTotalByFoiv: function (request) {
    return axios.get('/api/mpkAssignment/getTotalByFoiv', { params: request });
  },
  getTotalByCountry: function (request) {
    return axios.get('/api/mpkAssignment/getTotalByCountry', { params: request });
  },
  exportExcel: function (request) {
    return Utils.downloadFile('/api/mpkAssignment/exportExcel', 'MpkAssignment.xlsx', request);
  },
  exportFile: function (request) {
    return Utils.downloadFile('/api/mpkAssignment/exportFile', '', request);
  },
  find: function (id) {
    return axios.get('/api/mpkAssignment/find', { params: { id } });
  },
  update: function (data) {
    if (data.id > 0) return axios.put('/api/mpkAssignment/update', data, { params: { id: data.id } });
    else return axios.post('/api/mpkAssignment/create', data);
  },
  delete: function (id) {
    return axios.delete('/api/mpkAssignment/delete', { params: { id } });
  },
  deleteExecutor: function (id) {
    return axios.delete('/api/mpkAssignment/deleteExecutor', { params: { id } });
  },
  cancelStatus: function (executorsIds, data) {
    return axios.put('/api/mpkAssignment/cancelStatus', data, {
      params: { executorsIds },
    });
  },
  refuseReport: function (data) {
    return axios.put('/api/mpkAssignment/refuseReport', data, { params: { id: data.assignmentExecutorId } });
  },
  approveReport: function (data) {
    return axios.put('/api/mpkAssignment/approveReport', data, { params: { id: data.id } });
  },
  updateReport: function (data) {
    return axios.put('/api/mpkAssignment/updateReport', data, { params: { id: data.id } });
  },
  setPostponed: function (executorsIds, isPostponed) {
    return axios.put('/api/mpkAssignment/setPostponed', null, {
      params: { executorsIds, isPostponed },
    });
  },
  createChat: function (data) {
    return axios.post('/api/mpkAssignment/CreateChatForAssignment', null, {
      params: { assignmentId: data.assignmentId, orgId: data.orgId },
    });
  },
  getChats: function (id) {
    return axios.get('/api/mpkAssignment/getChats', { params: { id } });
  },
  exportFileMonitoring: function (request) {
    return Utils.downloadFile('/api/mpkAssignment/exportFileMonitoring', '', request);
  },
  sendComment: function (data) {
    return axios.post('/api/mpkAssignment/sendComment', data);
  },
  //Метод для isStart = true. Все. Ничего кроме не делает.
  startAssignment: function (data) {
    return axios.put('/api/mpkAssignment/start', data, { params: { id: data.assignmentId } });
  },
  // Метод для перевода в statusId = 2 конкретного executor
  takeInWork: function (executorId) {
    return axios.put('/api/mpkAssignment/takeInWork', null, { params: { executorId } });
  },
  startMultiple: function (data) {
    return axios.put('/api/mpkAssignment/startMultiple', data);
  },
  changeDate: function (data) {
    return axios.put('/api/mpkAssignment/changeDateMultiple', data);
  },
  getUploadTemplate: function () {
    return Utils.downloadFile('/api/mpkAssignment/getUploadTemplate', 'MpkAssignmentUploadTemplate.xlsx');
  },
  exportPptx: function (filters) {
    return Utils.downloadFile('/api/mpkAssignment/exportPptx', '', filters);
  },
  uploadFile(file, status) {
    let formData = new FormData();
    formData.append('file', file);
    return axios.post(`api/mpkAssignment/uploaddata/${status}`, formData);
  },
  returnFromDone: function (id) {
    return axios.put(`/api/mpkAssignment/returnFromDone/${id}`);
  },
};
